import { render, staticRenderFns } from "./ThreadDisplayPlaceholder.vue?vue&type=template&id=3ef4b836&scoped=true&"
import script from "./ThreadDisplayPlaceholder.vue?vue&type=script&lang=js&"
export * from "./ThreadDisplayPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./ThreadDisplayPlaceholder.vue?vue&type=style&index=0&id=3ef4b836&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef4b836",
  null
  
)

export default component.exports